
import { Box, HStack, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import type { CalculationSummaryHistoryItem } from 'BrokerTsLib/src/dtos'
import { useMemo } from 'react'
import { formatDateTime } from '../../Utils'
import { formatNumber } from '../../Utils/formatPrice'
import CustomTooltip from '../CustomTooltip'

export const OfferElapsedTime = ({
    items = []
}: {
    items?: CalculationSummaryHistoryItem[]
}) => {
    const sortedItems = useMemo(() => {
        return items instanceof Array ? [...items].sort(
            (a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
        ) : []
    }, [items])


    const lastSummary = sortedItems.at(0)
    const { active, color } = useMemo(
        () => getStatus(lastSummary?.calculationSummary.timeWsMs),
        [lastSummary]
    )

    if (!sortedItems.length)
        return null

    const tooltipLabel = (
        <Box maxW="none">
            <Table size="sm" variant="simple">
                <Thead>
                    <Tr>
                        <Th px={2} py={1}>Datum</Th>
                        <Th px={2} py={1}>Uživatel</Th>
                        <Th px={2} py={1} isNumeric>WS</Th>
                        <Th px={2} py={1} isNumeric>Zpracování</Th>
                        <Th px={2} py={1} isNumeric>Celkem</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {sortedItems.map((item) => {
                        const processingMs = item.calculationSummary.timeMs - item.calculationSummary.timeWsMs
                        const timeMs = item.calculationSummary.timeMs
                        const timeWsMs = item.calculationSummary.timeWsMs

                        const { color } = getStatus(timeMs)
                        const { color: colorWs } = getStatus(timeWsMs)

                        return (
                            <Tr key={`${item.dateCreated}-${item.userId}`}>
                                <Td px={2} py={1} whiteSpace="nowrap">
                                    {formatDateTime(item.dateCreated)}
                                </Td>

                                <Td px={2} py={1} whiteSpace="nowrap">
                                    {item.fullName}
                                </Td>

                                <Td px={2} py={1} isNumeric whiteSpace="nowrap" color={`${colorWs}.500`} fontWeight="bold">
                                    {formatNumber({
                                        value: timeWsMs,
                                        style: 'decimal',
                                    })} ms
                                </Td>

                                <Td px={2} py={1} isNumeric whiteSpace="nowrap" fontWeight="bold">
                                    {formatNumber({
                                        value: processingMs,
                                        style: 'decimal',
                                    })} ms
                                </Td>

                                <Td
                                    px={2}
                                    py={1}
                                    isNumeric
                                    whiteSpace="nowrap"
                                    fontWeight="bold"
                                    color={`${color}.500`}
                                >
                                    {formatNumber({
                                        value: timeMs,
                                        style: 'decimal',
                                    })} ms
                                </Td>
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
        </Box>
    )

    return (
        <CustomTooltip label={tooltipLabel} trigger='clickHover'>
            <HStack spacing={1}>
                {[0, 1, 2, 3].map((i) => (
                    <Box
                        key={i}
                        w={2}
                        h={2}
                        borderRadius="50%"
                        cursor='pointer'
                        bg={i < active ? `${color}.500` : 'gray.300'}
                    />
                ))}
            </HStack>
        </CustomTooltip>
    )
}

function getStatus(ms?: number) {
    if (!ms) return { active: 0, color: 'gray' }

    const sec = ms / 1000

    if (sec < 5) return { active: 1, color: 'green' }
    if (sec < 10) return { active: 2, color: 'blue' }
    if (sec < 20) return { active: 3, color: 'yellow' }

    return { active: 4, color: 'red' }
}
